import { IRedactedField } from '../common/defaults';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';

// types
export enum RedactedFieldsActionTypes {
  GET_REDACTED_FIELDS = 'GET_REDACTED_FIELDS',
  SAVE_REDACTED_FIELD = 'SAVE_REDACTED_FIELD'
}

export const getRedactedFields = (url: string) => {
  return async dispatch => {
    try {
      Api.get(url).then((result: ApiResponse<any>) => {
        let redactedFields = result.data.map(x => {
          return { id: x.id, name: x.name, isRedacted: false };
        });
        //dispatch(reduceRedactedFields(redactedFields));
        dispatch(reduceRedactedFields(result.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const saveRedactedField = (url: string, data: string) => {
  return async dispatch => {
    try {
      Api.post(url, data).then((result: ApiResponse<any>) => {
        dispatch(reduceSavedRedactedField(result.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceRedactedFields = (redactedFields: IRedactedField[]) => {
  return {
    type: RedactedFieldsActionTypes.GET_REDACTED_FIELDS,
    value: redactedFields
  };
};

export const reduceSavedRedactedField = (savedField: any) => {
  return {
    type: RedactedFieldsActionTypes.SAVE_REDACTED_FIELD,
    value: savedField
  };
};
